export default {"src":"/_next/static/media/Refresh-blu.10b339b3.svg","height":27,"width":27,"blurWidth":0,"blurHeight":0};